import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	background: #1d1d1d;
	color: ${({theme}) => theme.colorPalette.white};

	@media (min-width: ${breakpoints.medium}) {
		display: none;
	}
`;

const Item = styled(NavLink)`
	flex: 1;
	padding: 14px;
	font-family: ${({theme}) => theme.secondFont};
	font-weight: 500;
	line-height: 120%;
	letter-spacing: 0.32px;
	border-bottom: 2px solid ${({theme}) => theme.colorPalette.white};
	text-align: center;

	&.active {
		color: ${({theme}) => theme.colorPalette.secondary};
		border-bottom-color: ${({theme}) => theme.colorPalette.secondary};
	}
`;

export const TabsNavigation: FC = () => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			<Item to="/picks">{t("page.picks.tab.all_star")}</Item>
			{/*<Item to="/fan-vote">{t("page.picks.tab.fan_vote")}</Item>*/}
		</Wrapper>
	);
};
